import { render } from "./main-logo.vue?vue&type=template&id=11b9913b"
import script from "./main-logo.vue?vue&type=script&lang=js"
export * from "./main-logo.vue?vue&type=script&lang=js"
script.render = render

export default script